import { useState } from "react";
import { skills } from "@/data/profile";

const categories = ["All", "Civic", "Education", "Leadership"];

export const Skills = () => {
  const [filter, setFilter] = useState("All");
  const visible = filter === "All" ? skills : skills.filter((s) => s.category === filter);

  return (
    <section className="section section-alt" id="skills">
      <div className="container">
        <p className="eyebrow">04 · Skills</p>
        <h2 className="section-title">What I bring to the table</h2>
        <div className="filter-row" data-testid="skill-filter-row">
          {categories.map((c) => (
            <button
              key={c}
              className={`filter-btn ${filter === c ? "active" : ""}`}
              onClick={() => setFilter(c)}
              data-testid={`skill-filter-btn-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="skills-grid" data-testid="skills-grid">
          {visible.map((s) => (
            <div className="skill-card" key={s.name} data-testid={`skill-card-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <span className="skill-cat">{s.category}</span>
              <h3 className="skill-name">{s.name}</h3>
              <p className="skill-context">{s.context}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
